<template>
  <div class="contact-container">
    <!-- Page Header -->
    <div class="px-12 lg:px-32 py-16 pt-32">
      <h1 class="text-4xl font-bold mb-8">{{ $t('contact.title') }}</h1>
      <p class="text-gray-600 dark:text-gray-300 text-lg mb-8">
        {{ $t('contact.subtitle') }}
      </p>
    </div>

    <!-- Contact Section -->
    <contact-section></contact-section>
  </div>
</template>

<script>
import ContactSection from '@/sections/ContactSection.vue';

export default {
  name: 'ContactView',
  components: {
    ContactSection
  }
}
</script>

<style scoped>
.contact-container {
  min-height: 100vh;
}
</style>